import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgReminder = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height={24}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <title>reminder</title>
        <path
            clipRule="evenodd"
            d="M4.4091 4.40959C3.58618 5.23251 3.53396 6.53427 4.25243 7.41797C5.02435 6.11573 6.11526 5.02484 7.4175 4.25294C6.53381 3.53445 5.23203 3.58667 4.4091 4.40959ZM3.34844 8.65223C3.41875 8.72254 3.49124 8.78953 3.56569 8.85318C3.19995 9.83286 3.00001 10.8934 3.00001 12.0006C3.00001 14.4994 4.01837 16.7604 5.66272 18.3911C5.59315 18.4261 5.5279 18.4727 5.46981 18.5308L3.53047 20.4701C3.23758 20.763 3.23758 21.2379 3.53047 21.5308C3.82337 21.8237 4.29824 21.8237 4.59113 21.5308L6.53047 19.5915C6.61885 19.5031 6.68056 19.3981 6.7156 19.2866C8.1995 20.3647 10.0255 21.0006 12 21.0006C13.9745 21.0006 15.8005 20.3647 17.2844 19.2866C17.3195 19.3981 17.3812 19.5031 17.4696 19.5915L19.4089 21.5308C19.7018 21.8237 20.1767 21.8237 20.4696 21.5308C20.7624 21.2379 20.7624 20.763 20.4696 20.4701L18.5302 18.5308C18.4721 18.4727 18.4069 18.4261 18.3373 18.3911C19.9817 16.7604 21 14.4994 21 12.0006C21 10.8934 20.8001 9.83286 20.4343 8.85318C20.5088 8.78953 20.5813 8.72254 20.6516 8.65223C22.1161 7.18776 22.1161 4.8134 20.6516 3.34893C19.1871 1.88446 16.8128 1.88446 15.3483 3.34893C15.278 3.41925 15.211 3.49175 15.1473 3.56622C14.1677 3.2005 13.1072 3.00058 12 3.00058C10.8928 3.00058 9.83237 3.2005 8.85272 3.56622C8.78906 3.49175 8.72206 3.41925 8.65174 3.34893C7.18728 1.88446 4.81291 1.88446 3.34844 3.34893C1.88397 4.8134 1.88397 7.18776 3.34844 8.65223ZM19.7476 7.41797C20.4661 6.53427 20.4138 5.23251 19.5909 4.40959C18.768 3.58667 17.4662 3.53445 16.5825 4.25294C17.8848 5.02484 18.9757 6.11573 19.7476 7.41797ZM4.50001 12.0006C4.50001 7.85844 7.85788 4.50058 12 4.50058C16.1421 4.50058 19.5 7.85844 19.5 12.0006C19.5 16.1427 16.1421 19.5006 12 19.5006C7.85788 19.5006 4.50001 16.1427 4.50001 12.0006ZM12.75 6.75058C12.75 6.33637 12.4142 6.00058 12 6.00058C11.5858 6.00058 11.25 6.33637 11.25 6.75058V12.0006C11.25 12.1995 11.329 12.3903 11.4697 12.5309L14.0947 15.1559C14.3876 15.4488 14.8624 15.4488 15.1553 15.1559C15.4482 14.863 15.4482 14.3881 15.1553 14.0953L12.75 11.6899V6.75058Z"
            fill="current"
            fillRule="evenodd"
        />
    </svg>
);

export const ReminderIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgReminder}
        fontSize={fontSize}
    />
);
